// 引入Vue 引入Vuex
import Vue from 'vue';
import Vuex from 'vuex'; //需要先安装：npm install vuex --save
Vue.use(Vuex);

// import * as echarts from 'echarts'


//放数据
var state = {
	'userventer': {},
	'name': 'yaoyao',
	"count": 0,
	"width": 100,
	"token": "",
	"mouth": [],
	// 实训室上传图片
	"trainimg": "",
	"passwords": "",
	option: {
		tooltip: {
			trigger: 'axis'
		},
		radar: {
			radius: '55%',
			name: {
				textStyle: {
					fontSize: 14,
					color: '#333',
					// fontWeight: 900
				}
			},
			startAngle: 90,
			splitNumber: 5,
			splitArea: {
				show: true,
				areaStyle: {
					color: ['rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)', 'rgba(157,200,241,0.1)',
						'rgba(157,200,241,0.3)'
					]
				}
			},
			splitLine: {
				lineStyle: {
					color: '#ccc',
				}
			},
			axisLine: {
				lineStyle: {
					width: 1,
					color: '#ccc',
				}
			},
			// indicator: this.ldData
			// 标题
			indicator: [{
					name: "理论知识",
					max: 100
				},
				{
					name: "基本技能",
					max: 100
				},
				{
					name: "电务设备故障应急处置",
					max: 100
				},
				{
					name: "公务设备应急故障处置",
					max: 100
				},
				{
					name: "自然灾害应急处置",
					max: 100
				}
			]
		},
		series: {
			show: true,
			top: "1%",
			left: "0%",
			width: '100%',
			type: 'radar',
			itemStyle: {
				color: '#9DC8F1',
			},
			lineStyle: {
				color: '#9DC8F1'
			},
			areaStyle: {
				color: '#9DC8F1',
				opacity: 0.8
			},
			tooltip: {
				trigger: 'item'
			},
			data: [{
				name: '熟练程度',
				value: [89, 94, 99, 87, 87], //雷达图数据
			}]
		}
	},
	optionclone: {
		tooltip: {
			trigger: 'axis',
		},
		radar: {
			radius: '60%',
			name: {
				textStyle: {
					fontSize: 14,
					color: '#333',
					// fontWeight: 900
				}
			},
			startAngle: 90,
			splitNumber: 5,
			splitArea: {
				show: true,
				areaStyle: {
					color: ['rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)', 'rgba(157,200,241,0.1)',
						'rgba(157,200,241,0.3)'
					]
				}
			},
			splitLine: {
				lineStyle: {
					color: '#ccc',
				}
			},
			axisLine: {
				lineStyle: {
					width: 1,
					color: '#ccc',
				}
			},
			// indicator: this.ldData
			// 标题
			indicator: [],
			min: 0,
			max: 100,
		},

		series: {
			show: true,
			top: "1%",
			left: "5%",
			width: '100%',
			type: 'radar',
			itemStyle: {
				color: '#9DC8F1',
			},
			lineStyle: {
				color: '#9DC8F1'
			},
			areaStyle: {
				color: '#9DC8F1',
				opacity: 0.8
			},
			tooltip: {
				trigger: 'item'
			},
			data: [{
				value: [], //雷达图数据
				name: '熟练程度',
			}]
		}
	},

	option1: {
		title: {
			show: false,
			left: 'center',
			textStyle: { //数值样式
				color: "#333",
				fontSize: 16,
				fontWidth: "100",
			}
		},
		color: [{
			type: 'linear',
			x: 1,
			y: 0,
			x2: 1,
			y2: 1,

		}],
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'shadow'
			},
			formatter: function(params) {
				// console.log(params[0].value)
				return params[0].value + "/分钟";
			}

		},
		grid: {
			left: '2%',
			right: '4%',
			bottom: '3%',
			containLabel: true
		},
		xAxis: [{
			type: 'category',
			data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
			axisTick: {
				alignWithLabel: true
			},

		}],
		yAxis: [{
			minInterval: 1,
			type: 'value',
			name: "时长（m）",
			//---轴名称
			max: function(value) {
				return parseInt(value.max) + 2;
			},

		}],
		series: [{
			width: '100%',
			name: '实训时长',
			type: 'bar',
			barWidth: '70%',
			data: [23, 35, 42, 53, 66, 64, 78, 97, 12, 56, 67],
			itemStyle: {
				color: '#7CB5EC'
			}
		}]
	},


	option2: {
		title: {
			text: '',
			left: "center",
			show: false,
			textStyle: { //数值样式
				color: "#333",
				fontSize: 16,
				fontWidth: "100",
			}
		},
		tooltip: {
			trigger: 'axis'
		},
		grid: {
			left: '5%',
			right: '4%',
			bottom: '3%',
			containLabel: true
		},
		toolbox: {
			feature: {
				saveAsImage: {}
			}
		},
		xAxis: {
			type: 'category',
			boundaryGap: false,
			data: ['第一次', '第二次', '第三次', '第四次', '第五次', '第六次', '第七次', "第八次", "第九次", "第十次"]
		},
		yAxis: {
			type: 'value',
			name: "成绩分析（分）",
			//---轴名称
		},
		series: [{
			name: "吴耀明",
			type: "line",
			data: [24, 241, 53, 56, 47, 89, 98, 19, 64, 57, 86, 56, 34],
			smooth: true
		}, {
			name: "晨晨",
			type: "line",
			data: [254, 3, 53, 56, 67, 29, 18, 91, 64, 57, 86, 56, 34],
			smooth: true
		}, {
			name: "吴家山",
			type: "line",
			data: [234, 241, 53, 56, 67, 89, 88, 19, 64, 57, 86, 56, 34],
			smooth: true
		}, {
			name: "吴学斌",
			type: "line",
			data: [234, 241, 3, 55, 47, 80, 98, 29, 64, 57, 86, 56, 34],
			smooth: true
		}]
	},
	// 设备使用情况分析页面图表
	optionsb1: {
		tooltip: {
			trigger: 'item'
		},
		legend: {
			orient: 'horizontal',
			left: 'center',
			bottom: '-1%',
		},
		series: [{
			name: "设备使用情况分析",
			type: 'pie',
			radius: "75%",
			left: 'center',
			avoidLabelOverlap: false,
			label: {
				normal: {
					show: false,
					position: 'left'
				},

				emphasis: {
					show: true,
					textStyle: {
						fontSize: '16',
						fontWeight: '400',
						color: "#fff"
					}
				}
			},
			labelLine: {
				normal: {
					show: true
				}
			},
			data: [],
			emphasis: {
				itemStyle: {
					shadowBlur: 10,
					shadowOffsetX: 0,
					shadowColor: 'rgba(0, 0, 0, 0.5)'
				}
			}
		}]
	},
	optionsb2: {
		legend: {
			bottom: '0%',
			color: "#fff",
			textStyle: {
				color: "#fff"
			}
		},
		tooltip: {
			trigger: 'item'
		},
		series: [{
			name: '实时设备状态统计',
			type: "pie",
			radius: ['40%', '60%'],
			avoidLabelOverlap: false,
			label: {
				show: false,
				position: 'center'
			},
			textStyle: {
				color: "#fff",
			},
			emphasis: {
				label: {
					show: true,
					fontSize: '18',
					fontWeight: 'bold'
				}
			},
			labelLine: {
				show: false
			},
			data: []
		}]
	},
	optionsb3: {
		color: ['rgba(50, 229, 255, 1)', 'rgba(250, 207, 18, 1)'],
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'cross',
				crossStyle: {
					color: '#999'
				}
			}
		},
		grid: {
			top: '10%',
			left: '5%',
			right: '5%',
			bottom: '2%',
			containLabel: true
		},
		xAxis: [{
			type: 'category',
			data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
			axisLine: {
				show: true,
				lineStyle: {
					color: '#7B68EE'
				}
			},

			splitLine: {
				show: false,
				lineStyle: {
					color: 'blue',
					width: 1,
					type: 'solid'
				}
			},
			axisPointer: {
				type: 'shadow'
			},
		}],
		yAxis: [{
				type: 'value',
				name: `{legend|}  {value|实训时长}`,
				axisLabel: {
					color: '#FF6347',
					formatter: '{value}' + '小时',
				},
				axisLine: {
					show: true,
					lineStyle: {
						color: '#FFDEAD'
					}
				},
				splitLine: {
					show: false,
					lineStyle: {
						color: 'blue',
						width: 1,
						type: 'solid'
					}
				},
				minInterval: 40,
				nameTextStyle: {
					rich: {
						legend: {
							width: 12,
							height: 4,
							backgroundColor: '#6891ee'
						},
						value: {
							color: '#FF8C00'
						}
					}
				}
			},
			{
				type: 'value',
				name: `{legend|}  {value|实训人数} `,
				axisLabel: {
					color: '#FF6347',
					formatter: '{value}' + '人',

				},
				axisLine: {
					show: true,
					lineStyle: {
						color: '#66CDAA'
					}
				},
				minInterval: 50,
				splitLine: {
					lineStyle: {
						color: '#E6E6FA',
						width: 1,
						type: 'solid'
					}
				},
				nameTextStyle: {
					rich: {
						legend: {
							width: 12,
							height: 4,
							backgroundColor: '#a0f0f0'
						},
						value: {
							color: '#CD853F'
						}
					}
				}
			}
		],
		series: [{
				name: '实训时长',
				type: 'bar',
				data: [100, 120, 110, 130, 120, 110, 120, 110, 130, 120, 110, 110],
				barWidth: 14, // 柱状图的宽度
				itemStyle: {
					borderRadius: 8,
					color: "#6891ee"
				}
			},
			{
				name: '实训人数',
				type: 'line',
				yAxisIndex: 1,
				data: [60, 10, 50, 55, 60, 70, 60, 71, 81, 50, 40, 60],
				itemStyle: {
					color: "#a0f0f0",
				},
				lineStyle: {
					width: 4
				},
				smooth: true,
				showSymbol: false
			}
		]
	}




};
//放方法
var mutations = {
	// 修改用户信息
	chanusercenter(state, i) {
		state.usercenter = i
	},
	// 实训室图片上传
	changetrainimg(state, i) {
		// console.log(state, i)
		state.trainimg = i
	},
	scoolswidth(state, i) {
		// console.log(i)
		state.width = i
	},
	changechat(state, i) {
		state.option.series.data[0].value = i
	},
	changechatclone(state, i) {
		state.optionclone.series.data[0].value = i
	},
	changechatclonemax(state, i) {
		console.log(i, "最大值")
		state.optionclone.radar.max = i
	},
	changechatclonetitle(state, i) {
		state.optionclone.radar.indicator = i
	},

	changechatows(state, i) {
		// console.log(state,i)
		state.option1.series[0].data = i
	},
	changemouth(state, i) {
		state.option1.xAxis[0].data = i
		// console.log(i,"这是一个图表月份")
	},
	changechathree(state, i) {
		// console.log(state)
		state.option2.series = i
	},
	// 设备使用情况分析页面图表
	channgeoptionsb1(state, i) {
		this.state.optionsb1.series[0].data = i
		// console.log(i)
	},
	changeoptionsb2(state, i) {
		state.optionsb2.series[0].data = i
	},
	changeoptionsb3(state, i) {
		state.optionsb3.series[0].data = i.linesdata
		state.optionsb3.series[1].data = i.ciregcl
		console.log(i)
	},
	changetoken(state, i) {
		state.token = i
	},
	changeindicator(state, i) {
		state.option.radar.indicator = i
	},
	changepassaword(state, i) {
		state.passwords = i
	},




}
var getters = {
	getScoolswidth: state => state.width
}

//示例化
const store = new Vuex.Store({
	state, //es6中key与属性相同时的省略写法 相当于state：state
	mutations,
	getters
})


// 导出
export default store;